import React from 'react';

import { Modal, SvgIcon, Typography } from '@mui/material';

import { ReactComponent as CloseRoundedIcon } from 'mui/assets/icons/close-icon-rounded.svg';
import { StyledBox, StyledCloseButton, StyledModalHeader, StyledModalContent } from './styles';

const DS_Modal = ({
  open,
  handleClose,
  modalHeading,
  headingVariant = 'DS_h3',
  height = 'fit-content',
  ariaDescribedby,
  children,
}) => {
  return (
    <>
      <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby={ariaDescribedby}>
        <StyledBox $height={height}>
          <StyledModalHeader>
            <StyledCloseButton onClick={handleClose} data-qa="close-modal-button">
              <SvgIcon component={CloseRoundedIcon} data-qa="close-svg-icon" viewBox="0 0 24 24" />
            </StyledCloseButton>
            {modalHeading ? (
              <Typography id="modal-modal-title" variant={headingVariant} component="h2">
                {modalHeading}
              </Typography>
            ) : null}
          </StyledModalHeader>
          <StyledModalContent>{children}</StyledModalContent>
        </StyledBox>
      </Modal>
    </>
  );
};

export default DS_Modal;
